import type { PlatformLicense } from "@/features/platform-license/contract";
import type { CreatorPackage } from "@/features/creator-packages/contract";
export const plazaPopularQueries = ["都市", "古装", "职场", "甜美", "成熟", "反派"] as const;
export const plazaCategories = ["男形象", "女形象"] as const;
export const plazaSorts = ["recommend", "latest", "fans", "popular"] as const;

type PlazaCategory = (typeof plazaCategories)[number];
export type PlazaSort = (typeof plazaSorts)[number];

export type PlazaFilters = {
  query: string;
  minPrice?: number;
  maxPrice?: number;
  minFans?: number;
  tags?: string[];
  popular?: string[];
  category?: PlazaCategory;
  sort: PlazaSort;
  page: number;
  pageSize: number;
};

export type PlazaAvatar = {
  id: string;
  title: string;
  imageUrl?: string;
  leftImageUrl?: string;
  rightImageUrl?: string;
  videoUrl?: string;
  identityType: "网红" | "素人" | "";
  gender: "男" | "女" | "";
  category: PlazaCategory | "";
  height?: number;
  weight?: number;
  weightVerified?: boolean;
  fansCount: number;
  activeText: string;
  creatorPackages?: CreatorPackage[];
  license?: PlatformLicense;
  socialLinks?: { douyin?: string; xiaohongshu?: string };
  price: number;
  priceUnit: string;
  priceLabel: string;
  tags: string[];
  themes: string[];
  authorizationCount: number;
  viewCount: number;
  recommended: boolean;
  bio: string;
  city: string;
  lifePhotoUrls: string[];
  stillPhotoUrls?: string[];
  publishedAt: number;
};

export type PlazaCatalogMeta = {
  source?: "miniapp" | "demo";
  initialized: boolean;
  status: "ready" | "syncing" | "failed" | "empty";
  lastSyncedAt?: number;
  stale: boolean;
};

export type PlazaResult = {
  items: PlazaAvatar[];
  total: number;
  page: number;
  pageSize: number;
  pageCount: number;
  compatibilityMode: boolean;
  catalog: PlazaCatalogMeta;
};
